<template>
  <section class="sec-medicinal background-sec">
    <div class="sec-titr">
      <h1 class="sec-titr__title">عسل درمانی</h1>
    </div>
    <div class="medicinal">
      <ul class="medicinal-list">
        <li
          class="medicinal-item"
          v-for="item in medicinalList"
          :key="item.title"
        >
          <header class="medicinal-item-title" @click="readMedicinal">
            <span class="medicinal-item-title__text">{{ item.title }}</span>
            <i class="medicinal-item-title__icon fas fa-plus"></i>
          </header>
          <main class="medicinal-item-body">
            <div class="medicinal-item-content">
              <p class="medicinal-item-content__text">
                {{ item.content }}
              </p>
            </div>
          </main>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      medicinalList: [
        {
          title: "درمان بیماری قلبی",
          content:
            "مخلوطی از عسل و پودر دارچین را تهیه کنید و به جای مربا روی نان قرار دهید و به طور منظم در وعده صبحانه صرف کنید.این روش درکاهش کلسترول، جلوگیری از بروز حمله قلبی، تنفس راحت و تقویت ضربان قلب موثر است. بیماران مبتلا به حمله قلبی نیز با مصرف روزانه این مخلوط از حمله قلبی بعدی درامان خواهند بود. بررسی روی سالمندان در آمریکا و کانادا نشان داده است،با بالا رفتن سن شاهرگ های حیاتی و سیاهرگ ها خاصیت انعطاف پذیری خود را از دست می دهد.عسل و دارچین به شاهرگ ها و سیاهرگ ها قدرتی تازه میبخشد.",
        },
        {
          title: "جلوگیری از ریزش مو",
          content:
            "قبل از دوش گرفتن مخلوطی از مقداری روغن زیتون داغ،یک قاشق چای خوری عسل و یک قاشق پودر دارچین را به مدت ٥ تا ١٥ دقیقه روی سر قرار دهید و سپس آن را بشویید.",
        },
        {
          title: "درمان درد دندان",
          content:
            "مخلوطی از یک قاشق چای خوری پودر دارچین و ٥ قاشق چای خوری عسل تهیه کنید و روی دندان خراب بمالید.این عمل را ٣ بار در روز تکرار کنید تا درد تسکین یابد.",
        },
        {
          title: "درمان درد معده",
          content:
            "مصرف عسل و پودر دارچین علاوه بر درمان درد و نفخ معده،زخم معده را نیز درمان می کند.",
        },
        {
          title: "تقویت سیستم ایمنی",
          content:
            "استفاده روزانه از عسل و پودر دارچین سیستم ایمنی بدن را تقویت کرده و بدن را از حمله باکتری و ویروس محافظت می کند. دانشمندان دریافتند که عسل دارای مقدار زیادی ویتامین و آهن است. مصرف مداوم عسل گلبول های سفید خون را تقویت می کند تا بتواند با باکتری ها و بیماری های ویروسی مقابله کند.",
        },
        {
          title: " برطرف کردن سوء هاضمه",
          content:
            "قبل از هر وعده غذا،پودر دارچین را روی ٢ قاشق غذاخوری عسل بریزید و میل کنید تا از ترشح اضافی اسید معده رهایی پیدا کنید زیرا این مخلوط غذاهای سنگین را به راحتی هضم میکند",
        },
        {
          title: "جلوگیری از آنفلوآنزا",
          content:
            "دانشمندی در اسپانیا ثابت کرده که مخلوط عسل و دارچین دارای مواد مفید طبیعی است که از میکروب های آنفلوآنزا و سرماخوردگی جلوگیری به عمل می آورد .",
        },
        {
          title: "از بین بردن اثر خارش نیش های حشرات",
          content:
            "مخلوطی از یک سهم عسل، ٢ سهم آب ولرم و یک قاشق چای خوری پودر دارچین را روی قسمتی از بدن که احساس خارش می کنید،قرار دهید خارش و درد در عرض یک یا ٢ دقیقه فروکش خواهد کرد.",
        },
        {
          title: "درمان التهاب مفصل(آرتریت)",
          content:
            "روزانه،یک وعده صبح و یک وعده شب، مخلوطی از یک فنجان آب گرم، ٢ قاشق چای خوری عسل و یک قاشق چای خوری پودر دارچین مصرف شود.این مخلوط معجزه گر در صورت مصرف به طور منظم آرتریت های مزمن را نیز درمان می کند.بررسی های اخیر روی ٢٠٠ بیماری که قبل از صرف صبحانه از این مخلوط استفاده کردند نشان داد، ٧٣ نفر از آنان در عرض یک هفته کاملا از درد رهایی پیدا کردند و پس از یک ماه بیشتر افرادی که قادر به راه رفتن یا حرکت نبودند،بدون احساس هیچ دردی توانایی راه رفتن و تحرک خود را به دست آوردند.",
        },
        {
          title: "از بین بردن عفونت مثانه",
          content:
            "٢ قاشق غذاخوری عسل به همراه یک قاشق چای خوری پودر دارچین را با مقداری آب ولرم حل کنید و آن را بنوشید. این روش باعث می شود که میکروب های مثانه از بین برود.",
        },
        {
          title: "کاهش کلسترول",
          content:
            "٢ قاشق غذاخوری عسل را با ٣ قاشق چای خوری پودر دارچین در یک لیوان چای حل کنید و بنوشید.این کار میزان کلسترول خون را طی ٢ ساعت به ١٠ درصد کاهش می دهد.",
        },
        {
          title: "درمان سرماخوردگی",
          content:
            "به مدت ٣ روز از مخلوط یک قاشق غذاخوری عسل با یک چهارم قاشق چای خوری پودر دارچین استفاده کنید.این روش برای درمان سرفه مزمن و سرماخوردگی و سینوزیت به کار می رود.",
        },
        {
          title: "درمان ناباروری",
          content:
            "برای برطرف کردن این مشکل،به مردان توصیه می شود ٢ قاشق غذاخوری عسل را قبل از خواب میل کنند. در کشورهای چین، ژاپن و خاوردور که با مشکل ناباروری مواجه اند،در طول روز مخلوطی از مقداری پودر دارچین و یک دوم قاشق چای خوری عسل را به طور مرتب روی لثه و داخل دهان خود قرار می دهند تا مخلوط حاصل از طریق بزاق وارد بدن شود. زوجی که مدت ١٤ سال بچه دار نمی شدند با شروع مصرف عسل و دارچین پس از مدت کوتاهی صاحب دوقلو شدند",
        },
        {
          title: " جلوگیری از آنفلوآنزا",
          content:
            "دانشمندی در اسپانیا ثابت کرده که مخلوط عسل و دارچین دارای مواد مفید طبیعی است که از میکروب های آنفلوآنزا و سرماخوردگی جلوگیری به عمل می آورد .",
        },
        {
          title: "از بین بردن بوی بد دهان",
          content:
            "شما می توانید پس از بیدار شدن از خواب با محلولی از یک قاشق چای خوری عسل،مقداری پودر دارچین و آب گرم غرغره کنید تا در طول روز مشکل بوی بد دهان را نداشته باشید.",
        },
      ],
    };
  },
  methods: {
    readMedicinal(e) {
      let currentOpenHeader = document.querySelector(
        ".medicinal-item-title.active"
      );
      let header = e.currentTarget;
      let body = header.nextElementSibling;
      if (currentOpenHeader && currentOpenHeader !== header) {
        currentOpenHeader.classList.remove("active");
        currentOpenHeader.nextElementSibling.style.height = 0;
      }
      header.classList.toggle("active");
      if (header.classList.contains("active")) {
        body.style.height = body.scrollHeight + "px";
      } else {
        body.style.height = 0;
      }
    },
  },
   mounted() {
     let items=document.querySelectorAll('.medicinal-item')
    window.addEventListener("scroll", () => {
      items.forEach(item => {

      let itemTop = item.getBoundingClientRect().top;
      if(itemTop<90){
        item.style.transform='translateY(-50px)'
      }else{
        item.style.transform='translateY(0%)'
      }
        
      });
      
    });
  },
};
</script>

<style></style>
